import { isArray, isNumber, isObject, isString } from '../utils/typeUtils';

export type ReleaseEnvironment = {
  id?: number;
  name: string;
  releasedAt?: string;
  manifestVersion?: string;
  components: EnvironmentComponents[];
};

export type EnvironmentComponents = {
  id: number | undefined;
  version: string;
};

/**
 * リリース-環境 型ガード
 */
export const isComponent = (arg: unknown): arg is EnvironmentComponents => {
  const a = arg as EnvironmentComponents;

  return isObject(a) && isNumber(a.id) && isString(a.version);
};

export const isReleaseEnvironment = (
  arg: unknown,
): arg is ReleaseEnvironment => {
  const a = arg as ReleaseEnvironment;

  return (
    isObject(a) &&
    isString(a.name) &&
    isString(a.releasedAt) &&
    isString(a.manifestVersion)
    // isArray(a.components, isComponent)
  );
};

export const isReleaseEnvironments = (
  arg: unknown,
): arg is ReleaseEnvironment[] => isArray(arg, isReleaseEnvironment);
